import { render, staticRenderFns } from "./kcard.vue?vue&type=template&id=83c64694"
import script from "./kcard.vue?vue&type=script&lang=js"
export * from "./kcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports